<template>
  <!-- V1 Bölümü (Dokunulmadı) -->
  <section
    v-if="variants.v1 === variant"
    class="tabs -type-2 !tw-block"
  >
    <div class="tabs__test">
      <div class="container">
        <div class="row y-gap-15 justify-between items-end">
          <div class="col-lg-6">
            <div v-html="vars.titleHtml"></div>
          </div>

          <div class="col-auto">
            <div class="tabs__nav d-flex">
              <button
                class="button -outline-white size-80 text-20 text-white -prev js-tabsSlider-prev !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="-1"
                aria-label="Previous slide"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                class="button -outline-white size-80 text-20 text-white -next ml-20 js-tabsSlider-next !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="0"
                aria-label="Next slide"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slider js-tabsSlider">
      <div class="swiper-wrapper">
        <div
          v-for="(label, idx) in labels"
          :key="idx"
          class="swiper-slide"
          role="group"
          :aria-label="`${idx + 1} / ${labels.length}`"
        >
          <div class="container">
            <div class="row">
              <div class="col-auto">
                <div class="tabs__content">
                  <div class="tabs__bg">
                    <img :src="label.photo || ''" alt="image" />
                  </div>

                  <h4 style="color: var(--c-text_primary)">{{ label.title }}</h4>
                  <p
                    class="description-text pt-60 md:pt-30 tw-max-w-[800px]"
                    style="color: white !important"
                  >
                    {{ label.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- V2 Bölümü (Mobilde oklar başlığın altına gelecek şekilde güncellendi) -->
  <section
    v-if="variants.v2 === variant"
    class="tabs -type-2 !tw-block"
    :style="`background-color: var(--c-${vars.backgroundColor}) !important;`"
  >
    <BlockSymbol
      :position-text="String(vars?.blockPositionText || '')"
      :block-color="String(vars?.blockColor || '')"
      :block-opacity="Number(vars?.blockOpacityNumber || 1)"
    />

    <div
      class="tabs__test"
      
    >
      <div class="container">
        <!-- Burada mobilde flex-col → lg:flex-row -->
        <div class="row y-gap-15 justify-between flex-col items-start lg:flex-row lg:items-end">
          <div class="col-lg-6">
            <div class="text-62 md:text-38 fw-500" v-html="vars.titleHtml"></div>
          </div>

          <!-- mt-4 ile mobilde boşluk, lg:mt-0 ile büyük ekranda sıfırlama -->
          <div class="col-auto mt-4 lg:mt-0">
            <div class="tabs__nav d-flex">
              <button
                class="button -outline-white size-80 text-20 text-white -prev js-tabsSlider-prev !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="-1"
                aria-label="Previous slide"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                class="button -outline-white size-80 text-20 text-white -next ml-20 js-tabsSlider-next !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="0"
                aria-label="Next slide"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slider js-tabsSlider">
      <div class="swiper-wrapper">
        <div
          v-for="(label, idx) in labels"
          :key="idx"
          class="swiper-slide"
          role="group"
          :aria-label="`${idx + 1} / ${labels.length}`"
        >
          <div class="container">
            <div class="row">
              <div class="col-auto">
                <div
                  class="tabs__content"
                  :style="`color: var(--${vars.textColor}) !important;`"
                >
                  <!-- Burada görsel yoksa boş bırakılıyor -->
                  <div></div>

                  <h4>{{ label.title }}</h4>
                  <p
                    :style="`color: var(--${vars.textColor}) !important;`"
                    class="pt-60 md:pt-30 tw-max-w-[800px]"
                  >
                    {{ label.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ComponentMixin } from '~/mixins/component.mixin'
import BlockSymbol from '~/components/common/BlockSymbol.vue'

export default defineComponent({
  name: 'Theme7StorySlider',
  mixins: [ComponentMixin],

  components: {
    BlockSymbol,
  },

  data() {
    return {
      activeIndex: 0,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    }
  },

  computed: {
    labels() {
      return this.groupedVariables.labels
    },
    descriptions() {
      return this.groupedVariables.descriptions
    },
  },

  methods: {
    goTo(index: number) {
      this.activeIndex = index
    },
    onViewMore(item: any) {
      this.$emit('view-more', item)
    },
  },
})
</script>

<style scoped>
.description-text {
  color: white !important;
  text-fill-color: white !important;
  -webkit-text-fill-color: white !important;
}
.block {
  font-size: 32em !important;
  font-weight: 900 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1;
  margin: 35px;
  padding: 0;
  position: absolute;
}
</style>
